document.addEventListener('DOMContentLoaded', () => {
  const heroImage = document.querySelector('.hero-image');
  if (!heroImage) return;
  const video = document.createElement('video');
  video.className = heroImage.className;
  video.src = 'https://cdn.shopify.com/videos/c/o/v/ee5c765966ca4577a21bd3b19e9bf5f3.mp4';
  video.poster = 'https://cdn.shopify.com/s/files/1/0266/9458/2307/files/cudli-hero-video-poster-hq.png?v=1787032172';
  video.controls = true;
  video.playsInline = true;
  video.preload = 'metadata';
  video.setAttribute('aria-label', 'Cudli calming pet bed video');
  heroImage.replaceWith(video);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-review-carousel]').forEach((viewport) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const track = viewport.querySelector('.cudli-review-grid');
    if (!track) return;
    [...track.children].forEach((card) => track.appendChild(card.cloneNode(true)));
    let paused = false;
    let lastFrame = 0;
    let position = 0;
    let dragging = false;
    let dragStart = 0;
    let dragPosition = 0;
    const move = (time) => {
      if (!lastFrame) lastFrame = time;
      const elapsed = time - lastFrame;
      lastFrame = time;
      if (!paused) {
        position += elapsed * 0.04;
        const loopPoint = track.scrollWidth / 2;
        if (position >= loopPoint) position -= loopPoint;
        viewport.scrollLeft = position;
      }
      requestAnimationFrame(move);
    };
    ['mouseenter', 'focusin'].forEach((event) => viewport.addEventListener(event, () => { paused = true; }));
    ['mouseleave', 'focusout'].forEach((event) => viewport.addEventListener(event, () => { if (!dragging) paused = false; }));
    viewport.addEventListener('pointerdown', (event) => {
      dragging = true;
      paused = true;
      dragStart = event.clientX;
      dragPosition = position;
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const loopPoint = track.scrollWidth / 2;
      position = dragPosition - (event.clientX - dragStart);
      while (position < 0) position += loopPoint;
      while (position >= loopPoint) position -= loopPoint;
      viewport.scrollLeft = position;
    });
    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      paused = viewport.matches(':hover');
    };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    requestAnimationFrame(move);
  });
});
